import { FlagIcon as Flag } from "@heroicons/react/24/outline";
interface Props {
    countryCode: string;
}
const FlagIcon = (props: Props) => {
    const countryCode = props; 
  return <Flag />;
};
export default FlagIcon;
